import { lazy } from 'react';

import { Location } from '@core/Router/locations';

import { SCHEDULE_DEVICES_ROUTE } from './scheduleDevicesRoute';
import { SCHEDULE_V2_ROUTE } from './scheduleV2Route';

const ScheduleV2Page = lazy(() =>
    import(/* webpackChunkName: "schedule-v2" */ '@schedule/ui/ScheduleV2Page').then(m => ({
        default: m.ScheduleV2Page,
    })),
);

export const scheduleLocations: Location[] = [
    {
        url: SCHEDULE_V2_ROUTE.$path(),
        Component: ScheduleV2Page,
    },
    {
        url: SCHEDULE_DEVICES_ROUTE.$path(),
        Component: ScheduleV2Page,
    },
    {
        url: '/schedule-v2',
        Component: ScheduleV2Page,
    },
];
